import {useState} from 'react';
import cx from 'clsx';
import {Box, Group, Title} from '@mantine/core';
import classes from './PageNav.module.css';

const links = [
    {label: 'Input Argument', link: '#input', order: 1},
    {label: '--kmer (-k)', link: '#kvalue', order: 1},
    {label: '--output-dir (-o)', link: '#output-path', order: 1},
    {label: '--thread-count (-t)', link: '#config', order: 1},
    {label: '--help', link: '#help', order: 1},
];

export function JellyfishNav() {
    // State to manage the currently active link
    const [active, setActive] = useState('#input-fastq');

    // Function to scroll to the section and set the active link
    const scrollToSection = (link: string) => {
        const element = document.querySelector(link);
        if (element) {
            element.scrollIntoView({behavior: 'smooth'});
            setActive(link); // Set the active link
        }
    };

    const items = links.map((item) => (
        <Box<'a'>
            component="a"
            href={item.link}
            onClick={(event) => {
                event.preventDefault();
                scrollToSection(item.link);
            }}
            key={item.label}
            className={cx(classes.link, {[classes.linkActive]: active === item.link})}
            style={{paddingLeft: `calc(${item.order} * var(--mantine-spacing-md))`}}
        >
            {item.label}
        </Box>
    ));

    return (
        <Box
            top={136}
            pos='sticky'
            pr='xl'
            w={220}
        >
            <Group mb="md">
                <Title size="h6">ON THIS PAGE</Title>
            </Group>
            {items}
        </Box>
    );
}
